module.exports = "/images/coastal@3x.png?fdfbfe968ff3731f11fed798210fc30b";